/**
 * @fileoverview gRPC-Web generated client stub for external
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js')
const proto = {};
proto.external = require('./unit_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.external.UnitServiceClient =
  function(hostname, credentials, options) {
    if (!options) options = {};
    options['format'] = 'text';

    /**
     * @private @const {!grpc.web.GrpcWebClientBase} The client
     */
    this.client_ = new grpc.web.GrpcWebClientBase(options);

    /**
     * @private @const {string} The hostname
     */
    this.hostname_ = hostname;

  };


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.external.UnitServicePromiseClient =
  function(hostname, credentials, options) {
    if (!options) options = {};
    options['format'] = 'text';

    /**
     * @private @const {!grpc.web.GrpcWebClientBase} The client
     */
    this.client_ = new grpc.web.GrpcWebClientBase(options);

    /**
     * @private @const {string} The hostname
     */
    this.hostname_ = hostname;

  };


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.external.CreateUnitRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_UnitService_CreateUnit = new grpc.web.MethodDescriptor(
  '/external.UnitService/CreateUnit',
  grpc.web.MethodType.UNARY,
  proto.external.CreateUnitRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.external.CreateUnitRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.external.CreateUnitRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodInfo_UnitService_CreateUnit = new grpc.web.AbstractClientBase.MethodInfo(
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.external.CreateUnitRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.external.CreateUnitRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.external.UnitServiceClient.prototype.createUnit =
  function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ +
      '/external.UnitService/CreateUnit',
      request,
      metadata || {},
      methodDescriptor_UnitService_CreateUnit,
      callback);
  };


/**
 * @param {!proto.external.CreateUnitRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.external.UnitServicePromiseClient.prototype.createUnit =
  function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ +
      '/external.UnitService/CreateUnit',
      request,
      metadata || {},
      methodDescriptor_UnitService_CreateUnit);
  };


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.external.CreateUnitsRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_UnitService_CreateUnits = new grpc.web.MethodDescriptor(
  '/external.UnitService/CreateUnits',
  grpc.web.MethodType.UNARY,
  proto.external.CreateUnitsRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.external.CreateUnitsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.external.CreateUnitsRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodInfo_UnitService_CreateUnits = new grpc.web.AbstractClientBase.MethodInfo(
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.external.CreateUnitsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.external.CreateUnitsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.external.UnitServiceClient.prototype.createUnits =
  function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ +
      '/external.UnitService/CreateUnits',
      request,
      metadata || {},
      methodDescriptor_UnitService_CreateUnits,
      callback);
  };


/**
 * @param {!proto.external.CreateUnitsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.external.UnitServicePromiseClient.prototype.createUnits =
  function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ +
      '/external.UnitService/CreateUnits',
      request,
      metadata || {},
      methodDescriptor_UnitService_CreateUnits);
  };


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.external.GetUnitsRequest,
 *   !proto.external.GetUnitsResponse>}
 */
const methodDescriptor_UnitService_GetUnits = new grpc.web.MethodDescriptor(
  '/external.UnitService/GetUnits',
  grpc.web.MethodType.UNARY,
  proto.external.GetUnitsRequest,
  proto.external.GetUnitsResponse,
  /**
   * @param {!proto.external.GetUnitsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.external.GetUnitsResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.external.GetUnitsRequest,
 *   !proto.external.GetUnitsResponse>}
 */
const methodInfo_UnitService_GetUnits = new grpc.web.AbstractClientBase.MethodInfo(
  proto.external.GetUnitsResponse,
  /**
   * @param {!proto.external.GetUnitsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.external.GetUnitsResponse.deserializeBinary
);


/**
 * @param {!proto.external.GetUnitsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.external.GetUnitsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.external.GetUnitsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.external.UnitServiceClient.prototype.getUnits =
  function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ +
      '/external.UnitService/GetUnits',
      request,
      metadata || {},
      methodDescriptor_UnitService_GetUnits,
      callback);
  };


/**
 * @param {!proto.external.GetUnitsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.external.GetUnitsResponse>}
 *     Promise that resolves to the response
 */
proto.external.UnitServicePromiseClient.prototype.getUnits =
  function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ +
      '/external.UnitService/GetUnits',
      request,
      metadata || {},
      methodDescriptor_UnitService_GetUnits);
  };


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.external.GetUnitsByIDRequest,
 *   !proto.external.Unit>}
 */
const methodDescriptor_UnitService_GetUnitsByID = new grpc.web.MethodDescriptor(
  '/external.UnitService/GetUnitsByID',
  grpc.web.MethodType.UNARY,
  proto.external.GetUnitsByIDRequest,
  proto.external.Unit,
  /**
   * @param {!proto.external.GetUnitsByIDRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.external.Unit.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.external.GetUnitsByIDRequest,
 *   !proto.external.Unit>}
 */
const methodInfo_UnitService_GetUnitsByID = new grpc.web.AbstractClientBase.MethodInfo(
  proto.external.Unit,
  /**
   * @param {!proto.external.GetUnitsByIDRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.external.Unit.deserializeBinary
);


/**
 * @param {!proto.external.GetUnitsByIDRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.external.Unit)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.external.Unit>|undefined}
 *     The XHR Node Readable Stream
 */
proto.external.UnitServiceClient.prototype.getUnitsByID =
  function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ +
      '/external.UnitService/GetUnitsByID',
      request,
      metadata || {},
      methodDescriptor_UnitService_GetUnitsByID,
      callback);
  };


/**
 * @param {!proto.external.GetUnitsByIDRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.external.Unit>}
 *     Promise that resolves to the response
 */
proto.external.UnitServicePromiseClient.prototype.getUnitsByID =
  function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ +
      '/external.UnitService/GetUnitsByID',
      request,
      metadata || {},
      methodDescriptor_UnitService_GetUnitsByID);
  };


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.external.GetUnitsRequest,
 *   !proto.external.GetUnitsByFloorsResponse>}
 */
const methodDescriptor_UnitService_GetUnitsByFloors = new grpc.web.MethodDescriptor(
  '/external.UnitService/GetUnitsByFloors',
  grpc.web.MethodType.UNARY,
  proto.external.GetUnitsRequest,
  proto.external.GetUnitsByFloorsResponse,
  /**
   * @param {!proto.external.GetUnitsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.external.GetUnitsByFloorsResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.external.GetUnitsRequest,
 *   !proto.external.GetUnitsByFloorsResponse>}
 */
const methodInfo_UnitService_GetUnitsByFloors = new grpc.web.AbstractClientBase.MethodInfo(
  proto.external.GetUnitsByFloorsResponse,
  /**
   * @param {!proto.external.GetUnitsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.external.GetUnitsByFloorsResponse.deserializeBinary
);


/**
 * @param {!proto.external.GetUnitsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.external.GetUnitsByFloorsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.external.GetUnitsByFloorsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.external.UnitServiceClient.prototype.getUnitsByFloors =
  function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ +
      '/external.UnitService/GetUnitsByFloors',
      request,
      metadata || {},
      methodDescriptor_UnitService_GetUnitsByFloors,
      callback);
  };


/**
 * @param {!proto.external.GetUnitsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.external.GetUnitsByFloorsResponse>}
 *     Promise that resolves to the response
 */
proto.external.UnitServicePromiseClient.prototype.getUnitsByFloors =
  function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ +
      '/external.UnitService/GetUnitsByFloors',
      request,
      metadata || {},
      methodDescriptor_UnitService_GetUnitsByFloors);
  };


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.external.UpdateUnitRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_UnitService_UpdateUnit = new grpc.web.MethodDescriptor(
  '/external.UnitService/UpdateUnit',
  grpc.web.MethodType.UNARY,
  proto.external.UpdateUnitRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.external.UpdateUnitRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.external.UpdateUnitRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodInfo_UnitService_UpdateUnit = new grpc.web.AbstractClientBase.MethodInfo(
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.external.UpdateUnitRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.external.UpdateUnitRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.external.UnitServiceClient.prototype.updateUnit =
  function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ +
      '/external.UnitService/UpdateUnit',
      request,
      metadata || {},
      methodDescriptor_UnitService_UpdateUnit,
      callback);
  };


/**
 * @param {!proto.external.UpdateUnitRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.external.UnitServicePromiseClient.prototype.updateUnit =
  function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ +
      '/external.UnitService/UpdateUnit',
      request,
      metadata || {},
      methodDescriptor_UnitService_UpdateUnit);
  };


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.external.DeleteUnitRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_UnitService_DeleteUnit = new grpc.web.MethodDescriptor(
  '/external.UnitService/DeleteUnit',
  grpc.web.MethodType.UNARY,
  proto.external.DeleteUnitRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.external.DeleteUnitRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.external.DeleteUnitRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodInfo_UnitService_DeleteUnit = new grpc.web.AbstractClientBase.MethodInfo(
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.external.DeleteUnitRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.external.DeleteUnitRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.external.UnitServiceClient.prototype.deleteUnit =
  function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ +
      '/external.UnitService/DeleteUnit',
      request,
      metadata || {},
      methodDescriptor_UnitService_DeleteUnit,
      callback);
  };


/**
 * @param {!proto.external.DeleteUnitRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.external.UnitServicePromiseClient.prototype.deleteUnit =
  function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ +
      '/external.UnitService/DeleteUnit',
      request,
      metadata || {},
      methodDescriptor_UnitService_DeleteUnit);
  };


module.exports = proto.external;
